import { getFormattedDate } from "./time";

export function GenerateString(length) {
  var result = "";
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function parseComplexDate(currentDate) {
  let myDate = new Date(currentDate);
  const offset = myDate.getTimezoneOffset();
  myDate = new Date(myDate.getTime() - offset * 60 * 1000);
  const finalDate = myDate.toISOString().split("T")[0];
  return finalDate;
}

export function getShiftDate(shift) {
  const todayDate = new Date();
  const todayInt = parseInt(getCurrentDayNumber());
  const shiftDayInt = parseInt(shift.day);

  let shiftDate = new Date(todayDate);
  if (shiftDayInt >= todayInt) {
    shiftDate.setDate(todayDate.getDate() + (shiftDayInt - todayInt));
  } else {
    shiftDate.setDate(todayDate.getDate() + (7 - todayInt + shiftDayInt));
  }
  return getFormattedDate(shiftDate);
}

export function getCurrentDayNumber() {
  const dayOfWeek = new Date().getDay();
  if (dayOfWeek === 0) {
    return "7";
  } else {
    return dayOfWeek.toString();
  }
}

export async function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function isPickUp(type) {
  if (!type) return true;
  return type.toString() === "100" || type.toString() === "PICK_UP";
}
